import React from "react";
import "./SetlistArt.css";

// Setlist cover mosaic (founder decision): wherever a setlist purchase renders
// as a row or card, its art is the first four songs' album covers in a 2×2
// grid — every playlist looks like itself instead of a generic note tile.
// The PARENT supplies the size + radius via className (fps-art, rh-art,
// track-image, …); this component only splits that box into quarters.
//
// Fewer than 4 images → the first one fills the box like a normal cover;
// none → renders null so the caller's existing fallback keeps working.

const SetlistArt: React.FC<{
  images?: string[] | null;
  className?: string;
  alt?: string;
}> = ({ images, className, alt = "" }) => {
  const imgs = (images || []).filter(Boolean);
  if (imgs.length >= 4) {
    return (
      <div className={`setlist-mosaic ${className || ""}`.trim()} aria-label={alt}>
        {imgs.slice(0, 4).map((src, i) => (
          <img key={i} src={src} alt="" loading="lazy" />
        ))}
      </div>
    );
  }
  if (imgs.length >= 1) {
    return <img className={className} src={imgs[0]} alt={alt} loading="lazy" />;
  }
  return null;
};

export default SetlistArt;
